import { render } from "./ViewFAQ.vue?vue&type=template&id=a879f10e&scoped=true"
const script = {}

import "./ViewFAQ.vue?vue&type=style&index=0&id=a879f10e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a879f10e"]])

export default __exports__